import useEffectOnce from "hooks/useEffectOnce";
import { useState, useRef, useLayoutEffect } from "react";
import { useSelector } from "react-redux";
import { debounce } from "utils/debounce";

const CommonItemInfoName = ({ name, type = '' }) => {
  const [fontSize, setFontSize] = useState('initial');
  const [positionStyles, setPositionStyles] = useState({})
  const { activeItem } = useSelector((state) => state.cards);
  const nameRef = useRef(null);

  const getPositionStyles = () => {
    if (nameRef.current) {
      const height = nameRef.current.getBoundingClientRect().height;
      // const percent = name.length > 21 ? 52 : 50;
      setPositionStyles({
        position: 'absolute',
        top: `calc(50% - ${height / 2}px)`,
        left: 0,
        right: 0
      });
    }
  };

  const handleResize = debounce(() => {
    const newSize = Math.floor(Math.max(15, window.innerWidth / 90));
    setFontSize(`${newSize}px`);
  }, 100);

  const getName = () => {
    if (type.toLowerCase() === 'prize') {
      return `$${name}`;
    } else if (name.length > 40) {
      const lastSpaceIndex = name.lastIndexOf(' ', 40);
      const trimmedName = lastSpaceIndex !== -1 ? name.slice(0, lastSpaceIndex) : name.slice(0, 40);
      return trimmedName + ' ...';
    } else {
      return name;
    }
  };


  useEffectOnce(() => {
    handleResize();
    getPositionStyles();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  useLayoutEffect(() => {
    if (nameRef.current) {
      nameRef.current.style.fontSize = fontSize;
    }
    getPositionStyles();
  }, [fontSize, activeItem, name]);

  return (
    <b
      className="cards-list__block-item-data-text"
      ref={nameRef}
      style={positionStyles}
    >
      {getName()}
    </b>
  );
};

export default CommonItemInfoName;
